/**
 * Pagination hooks for TableAdv component
 */
import { useState, useEffect, useMemo } from "react";
import { calculatePaginationValues } from "./tablePaginationUtils";

/**
 * Hook for managing table pagination
 * @param {Object} options - Pagination options
 * @returns {Object} Pagination state and handlers
 */
export const useTablePagination = ({
  serverPagination = false,
  page = 1,
  limit = 25,
  rows = [],
  totalCount = 0,
  onPaginationChange = () => { },
  onLimitChange = () => { },
}) => {
  const [currentPage, setCurrentPage] = useState(page);
  const [rowsPerPage, setRowsPerPage] = useState(limit);

  useEffect(() => {
    if (serverPagination) {
      setCurrentPage(page);
    }
  }, [page, serverPagination]);

  useEffect(() => {
    if (serverPagination) {
      setRowsPerPage(limit);
    }
  }, [limit, serverPagination]);

  const activePage = serverPagination ? page : currentPage;
  const activeRowsPerPage = serverPagination ? limit : rowsPerPage;

  const { startIndex, endIndex, paginatedData, totalPages } = useMemo(() => {
    return calculatePaginationValues(
      serverPagination,
      activePage,
      activeRowsPerPage,
      activePage,
      activeRowsPerPage,
      rows,
      totalCount
    );
  }, [serverPagination, activePage, activeRowsPerPage, rows, totalCount]);

  const handlePageChange = (newPage) => {
    if (serverPagination) {
      onPaginationChange(newPage);
    } else {
      setCurrentPage(newPage);
    }
  };

  // const handleRowsPerPageChange = (value) => {
  //   const newRowsPerPage = Number(value);
  //   if (serverPagination) {
  //     onLimitChange(newRowsPerPage);
  //   } else {
  //     const newTotalPages = Math.ceil(rows.length / newRowsPerPage);
  //     const newPage = Math.min(
  //       Math.ceil((currentPage * rowsPerPage) / newRowsPerPage),
  //       newTotalPages
  //     );
  //     setRowsPerPage(newRowsPerPage);
  //     setCurrentPage(newPage);
  //   }
  // };
  //This is changed due to page numbers addition in table component 
  const handleRowsPerPageChange = (value) => {
    const newRowsPerPage = Number(value);
    if (serverPagination) {
      onLimitChange(newRowsPerPage);
    } else {
      const firstRowIndex = (currentPage - 1) * rowsPerPage;
      const newTotalPages = Math.ceil(rows.length / newRowsPerPage);
      const newPage = (newTotalPages === 0) ? 1 : Math.min(Math.floor(firstRowIndex / newRowsPerPage) + 1, newTotalPages);
      setRowsPerPage(newRowsPerPage);
      setCurrentPage(newPage);
    }
  };

  return {
    currentPage: activePage,
    rowsPerPage: activeRowsPerPage,
    startIndex,
    endIndex,
    paginatedData,
    totalPages,
    handlePageChange,
    handleRowsPerPageChange,
  };
};
